import { contains, has } from 'underscore';
import { globalizationModelSetup } from '@bingads-webui-campaign/ads-globalization';

const langCodeMapper = {
  'zh-cn': 'SimplifiedChinese',
  'zh-hans': 'SimplifiedChinese',
  ar: 'Arabic',
  bg: 'Bulgarian',
  bs: 'Bosnian',
  cs: 'Czech',
  da: 'Danish',
  de: 'German',
  el: 'Greek',
  en: 'English',
  es: 'Spanish',
  et: 'Estonian',
  fi: 'Finnish',
  fr: 'French',
  hr: 'Croatian',
  hu: 'Hungarian',
  is: 'Icelandic',
  it: 'Italian',
  iw: 'Hebrew',
  ja: 'Japanese',
  lt: 'Lithuanian',
  lv: 'Latvian',
  mk: 'Macedonian',
  mt: 'Maltese',
  nl: 'Dutch',
  no: 'Norwegian',
  pl: 'Polish',
  pt: 'Portuguese',
  ro: 'Romanian',
  ru: 'Russian',
  sk: 'Slovak',
  sl: 'Slovenian',
  sq: 'Albanian',
  sr: 'Serbian',
  sv: 'Swedish',
  tr: 'Turkish',
  zh: 'TraditionalChinese',
};

const getLocalLanguage = locale => locale.split('-')[0];

const FALLBACK_LANGUAGE_CODE = 'en';
const DEFAULT_LANGUAGE = 'English';
const localeToLanguage = (locale = '') => {
  const lcLocale = locale.toLocaleLowerCase();
  const localesToTry = [lcLocale, getLocalLanguage(lcLocale), FALLBACK_LANGUAGE_CODE];
  for (let i = 0; i < localesToTry.length; i += 1) {
    const localeToTry = localesToTry[i];
    if (has(langCodeMapper, localeToTry)) {
      return langCodeMapper[localeToTry];
    }
  }
  return DEFAULT_LANGUAGE;
};

export const getLanguage = (permissions, locale) => {
  const { LANGUAGES: supportedLanguages } = globalizationModelSetup({ permissions, culture: locale });
  const language = localeToLanguage(locale);
  if (contains(supportedLanguages, language)) {
    return language;
  } else if (permissions && permissions.IsDomesticSimplifiedChineseEnabled && contains(supportedLanguages, 'SimplifiedChinese')) {
    return 'SimplifiedChinese';
  }
  return DEFAULT_LANGUAGE;
};
